import type { IconProps } from '../types';

export function ProfileIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="m600 262.5c-123.75 0-225 101.25-225 225s101.25 225 225 225 225-101.25 225-225-101.25-225-225-225zm0 375c-82.5 0-150-67.5-150-150s67.5-150 150-150 150 67.5 150 150-67.5 150-150 150z"
          fill="currentColor"
        />
        <path
          d="m600 75c-290.62 0-525 234.38-525 525 0 142.5 58.125 273.75 150 367.5 22.5 22.5 46.875 43.125 75 61.875 84.375 60 187.5 93.75 300 93.75s215.62-35.625 300-93.75c26.25-18.75 50.625-39.375 75-61.875 93.75-95.625 150-225 150-367.5 0-290.62-234.38-525-525-525zm0 975c-112.5 0-213.75-41.25-292.5-108.75 20.625-67.5 82.5-116.25 155.62-116.25h275.62c73.125 0 135 48.75 155.62 116.25-80.625 67.5-181.88 108.75-294.38 108.75zm350.62-168.75c-39.375-78.75-120-131.25-211.88-131.25h-275.62c-93.75 0-174.38 54.375-211.88 131.25-63.75-76.875-101.25-174.38-101.25-281.25 0-247.5 202.5-450 450-450s450 202.5 450 450c0 106.88-37.5 204.38-99.375 281.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
